import RightPopupComponent from "components/RightPopup";

import Select from "components/Select";
import DentalFormula from "components/DentalFormula";

import { ReactComponent as ExpandIcon } from 'icons/components/expand.svg';
import { ReactComponent as CollapseIcon } from 'icons/components/collapse.svg';
import { ReactComponent as FilterIcon } from 'icons/components/filter.svg';

import './index.less';
import './themes/default.less';

export default class InspectionPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.sectionForInspection = [1, 3, 25, 4, 16, 21];

        this.defaultState = {
            info: {
                sections: { ...this.sections },
                teeth: [],
                diagnosisTeeth: {},
                selectedTeeth: [],
                occlusion: "OCCLUSION_NOT_DEFINED"
            },
            currentTag: 0,
            currentText: "",
            expand: false,
            currentArea: false,
            selectPhrase: false,
            usePhrases: {
                diagnosis: [],
                icdDiagnosis: [],
                complaints: [],
                developPresDis: [],
                anamnesis: [],
                examination: [],
            },
            renderBodyFlag: false,
        };

        this.state = { ...this.defaultState };

        this.phrase = [];
    }

    get popupName() {
        return "ankAdultPopup";
    }

    componentDidUpdate() {
        super.componentDidUpdate();
        const { selectedTeeth } = this.state.info;
        if (this.teethSelector)
            this.teethSelector.setTeeth(selectedTeeth);
    }

    setInfoState(key, value) {
        this.state.info[key] = value;
    }

    changeInfoState(key, value) {
        const info = this.state.info;
        info[key] = value;
        this.setState({ info });
    }

    onContinue() {
        this.changeState("renderBodyFlag", true);
    }

    show(info, type, hideCb) {
        this.hideCb = hideCb;

        this.dialogTitle = `^${this.tr(type === "diary" ? "client.createDiaryFor" : "client.createInspectionFor")} ${this._helper.date.toStr(new Date(), "D MMMM YYYY")}`;
        this.dialogSaveTitle = "main.continue";
        this.type = type;

        const defaultInfo = {
            sections: { ...this.sections },
            teeth: [],
            diagnosisTeeth: {},
            selectedTeeth: []
        };

        this.state.info = { ...defaultInfo, ...info };
        this.phrase = [...new Set(info.phrase.flatMap(phrase => phrase.tags))].map((it, i) => ({ id: i, name: it }));

        super.show();
    }

    setSection(data) {
        data.forEach(it => {
            this.textAnalyzer(it.medSection.id, it.value, it.id);
        });
    }

    getInfoMedSection(id) {
        const { info } = this.state;
        this._request.medSection.getInfoMedSection(id).then(result => {
            const phrase = result?.data?.phrases || [];
            /*const tags = [...new Set(phrase.flatMap(phras => phras.tags))].map((it, i) => ({ id: i, name: it }));*/
            /*this.changeState("info", { ...info, phrase, tags });*/
            this.changeState("info", { ...info, phrase });
        });
    }

    getDiagnosisTeeth(data) {
        const { diagnosis } = this._config;
        const mapDiagnosis = diagnosis.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
        const diagnosisTeeth = data.dentalFormula.reduce((acc, it, i) => {
            if (it)
                acc[i + 1] = it.split(",").map(item => mapDiagnosis[+item]);
            return acc;
        }, {});
        return diagnosisTeeth;
    }

    async onShow() {
        const { info } = this.state;

        this._helper.showLoading();

        if (this.type === "diary" && info.medDiarieId) {
            const resp = await this._request.medDiary.getMedDiary(info.medDiarieId);
            if (resp?.data[0]) {
                this.setSection(resp.data[0].medDiaryHasMedSections);
                info.selectedTeeth = resp.data[0].medDiaryHasTeeth;
                this.changeState("info", { ...info });
            }
        }

        if (this.type === "inspection" && info.medInspectionId) {
            const resp = await this._request.medInspection.getMedInspection(info.medInspectionId);
            if (resp?.data[0]) {
                this.setSection(resp.data[0].medInspectionHasMedSection);
                info.diagnosisTeeth = this.getDiagnosisTeeth(resp.data[0]);
                info.occlusion = resp.data[0].occlusion;
                this.changeState("info", { ...info });
            }
        }

        this._helper.hideLoading();

    }

    save() {
        const { renderBodyFlag } = this.state;

        if (!renderBodyFlag) {
            this.changeState("renderBodyFlag", true);
            return;
        }

        this.saveData();
    }

    saveData() {
        this.hideCb(this.state.info);
        this.hide();
    }

    onHide() {
        this.setState({
            currentTag: 0,
            currentText: "",
            expand: false,
            currentArea: false,
            selectPhrase: false,
            usePhrases: {
                diagnosis: [],
                icdDiagnosis: [],
                complaints: [],
                developPresDis: [],
                anamnesis: [],
                examination: [],
            },
            renderBodyFlag: false,
        });
    }

    onExpand() {
        const { expand, info } = this.state;
        const { medSection } = info;

        this.toggleState("expand");
        medSection.forEach(it => {
            this["medSection" + it.id].expande = !expand;
        });
        this.changeState("currentText", "");
    }

    setCurrentText(value) {
        this.changeState("currentText", value);
    }

    getLastPhrase(result) {
        if (result.length > 0) {
            const lastRow = result[result.length - 1];
            if (lastRow.length > 0) {
                const lastSentence = lastRow[lastRow.length - 1];
                return this.setCurrentText(lastSentence);
            }
        }

        return this.setCurrentText("");
    }

    searchWait() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            clearTimeout(this.searchTimer);
            this.search();
        }, 500);
    }

    onChangeAreaVal(source, value) {
        const { sections } = this.state.info;
        sections[source] = { ...sections[source], value };
        this.changeInfoState("sections", sections);
        this["area" + source].content = value;
    }

    textAnalyzer(id, value, idValue) {
        const { sections } = this.state.info;
        let result = [];
        if (value) {
            const rowsArray = value.split("\n");
            result = rowsArray.map(it => it.split(". "));
            this.getLastPhrase(result);
        } else {
            this.setCurrentText("");
        }

        const newValue = { result, value };
        if (idValue)
            newValue.idValue = idValue;
        else if (sections[id])
            newValue.idValue = sections[id].idValue;

        const newSections = { ...sections, [id]: newValue };

        this.changeInfoState("sections", newSections);
    }

    arrayToText(id) {
        const { currentText, info } = this.state;
        const { sections } = info;
        const arr = (sections[id]?.result || []);
        let text = "";
        arr?.forEach((row, i) => {
            if (currentText && i === arr.length - 1)
                row.pop();
            row?.forEach(it => {
                if (it)
                    text += it + ". ";
            });
            text += "\n";
        });

        return text ? text.slice(0, -1) : "";
    }

    onChangeArea(id, value) {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            clearTimeout(this.searchTimer);
            this.textAnalyzer(id, value);
        }, 500);
    }

    onClickArea(id) {
        this.getInfoMedSection(id);
        this.changeState("currentArea", id);
    }

    onClickOvalText(value) {
        const { currentArea } = this.state;

        let newValue = this.arrayToText(currentArea) + value;

        if (this["medSection" + currentArea])
            this["medSection" + currentArea].content = newValue;

        this.textAnalyzer(currentArea, newValue);
        this.setCurrentText("");
    }

    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    sortPhrases(currentText, phraseFilter) {
        const escapedText = this.escapeRegExp(currentText);
        const regex = new RegExp(`^(${escapedText})`, 'gi');

        phraseFilter.sort((a, b) => {
            const aMatch = a.customName.match(regex);
            const bMatch = b.customName.match(regex);
            const res = (aMatch && bMatch) ? aMatch[0].localeCompare(bMatch[0]) : aMatch ? -1 : bMatch ? 1 : a.customName.localeCompare(b.customName);
            return res;
        });
        return phraseFilter;
    }

    getPhrase(phrase, tags) {
        const { currentText, currentTag } = this.state;
        const ct = tags[currentTag];
        const phraseFilter = phrase.filter(it => ct && it.tags.includes(ct.name));
        const phrasesState = currentText ? this.sortPhrases(currentText, phraseFilter) : phraseFilter;
        return phrasesState;
    }

    onKeyDown(e) {
        const { selectPhrase, info } = this.state;
        const { phrase } = info;

        if (e.key === "ArrowDown") {
            this._helper.stopEvent(e);
            if (selectPhrase === false || selectPhrase >= phrase.length - 1)
                this.changeState("selectPhrase", 0);
            else
                this.changeState("selectPhrase", selectPhrase + 1);
        } else if (e.key === "ArrowUp") {
            this._helper.stopEvent(e);
            if (selectPhrase === false || selectPhrase === 0)
                this.changeState("selectPhrase", phrase.length - 1);
            else
                this.changeState("selectPhrase", selectPhrase - 1);
        } else if (e.key === "Enter" && selectPhrase !== false) {
            this._helper.stopEvent(e);
            this.onClickOvalText(phrase[selectPhrase].customName, phrase[selectPhrase].id);
            this.changeState("selectPhrase", false);
        }
    }

    onRenderTeeth() {
        this.setPopupBackTitle("client.teethSelection", this.onRenderBody.bind(this));

        this.changeState("renderBodyFlag", false);
    }

    onRenderBody() {
        this.dialogTitle = `^${this.tr("client.createInspectionFor")} ${this._helper.date.toStr(new Date(), "D MMMM YYYY")}`;
        this.changeState("renderBodyFlag", true);
    }

    getTextTeeth(teeth) {
        return teeth.join(",");
    }

    onChangeDiagnosis(selectDiag) {
        const { diagnosisTeeth } = this.state.info;
        diagnosisTeeth[selectDiag.teethId] = selectDiag.diag;
        this.changeInfoState(diagnosisTeeth);
    }

    onChangeTeeth(selected) {
        this.changeInfoState("selectedTeeth", selected);
    }

    onChangeTag(ind) {
        this.changeState("currentTag", ind);
    }

    onChangeOcclusion(id) {
        this.changeInfoState("occlusion", id);
    }

    renderTeeth() {
        const { diagnosisTeeth, occlusion } = this.state.info;
        console.log("renderTeeth", diagnosisTeeth);

        const props = {
            ref: el => this.teethSelector = el,
            showBite: this.type === "diary" ? false : true,
            showTeeth: this.type === "diary" ? true : false,
            choiceDiagnosis: this.type === "diary" ? false : true,
            onChangeDiagnosis: this.type === "diary" ? null : this.onChangeDiagnosis.bind(this),
            showOralJaw: this.type === "diary" ? true : false,
            onChangeTeeth: this.onChangeTeeth.bind(this),
            diagnosisTeeth: diagnosisTeeth,
            occlusion: occlusion,
            onChangeOcclusion: this.onChangeOcclusion.bind(this)
        };

        return <DentalFormula {...props} />;
    }

    renderBody() {
        const { currentTag, expand, info, currentText, selectPhrase } = this.state;
        const { phrase, selectedTeeth, tags, medSection, sections } = info;
        const phrasesState = this.getPhrase(phrase, tags);

        return (
            <div className="inspectionPage">
                <div className="flex gap8 col">
                    {/*this.insertRowInfo("client.category", "client.dentistry")*/}
                    {/*this.insertRowInfo("client.phrases", "client.standard")*/}
                    {this.type === "diary" && <div onClick={this.onRenderTeeth.bind(this)}>
                        {this.insertRowInfo(this._helper.string.capitalize(this.tr("client.teeth")), this.getTextTeeth(selectedTeeth))}
                    </div>}
                </div>
                <div className="flex">
                    <div className="flex col">
                        <div className="contentBlockIns flex col">
                            <div className="headerCBInsL flex between centerV">
                                {this.insertContentTitle("client.newTreatment")}
                                <div className="expand hand flex centerV" onClick={this.onExpand.bind(this)}>
                                    {expand ? <CollapseIcon /> : <ExpandIcon />}
                                </div>
                            </div>
                        </div>
                        <div className="contInputs flex col gap24 scrolling">
                            {medSection.map((it, i) => (this.type === "diary" || this.sectionForInspection.includes(it.id)) && <div key={i}>{this.insertAreaInput({
                                ref: el => this["medSection" + it.id] = el,
                                text: it.name,
                                content: sections[it.id] ? sections[it.id].value : "",
                                onChange: this.onChangeArea.bind(this, it.id),
                                onClick: this.onClickArea.bind(this, it.id),
                                onKeyDown: this.onKeyDown.bind(this)
                            })}</div>)}
                        </div>
                    </div>
                    <div className="flex col">
                        <div className="headerCBIns flex between centerV">
                            {this.insertContentTitle("client.phrases")}
                            <Select
                                value={currentTag}
                                items={tags}
                                onChange={this.onChangeTag.bind(this)}
                                leftIcon={<FilterIcon />}
                            />
                        </div>
                        <div className="contPhrases flex col gap8 scrolling">
                            {phrasesState.map((it, i) => i < 100 && (
                                <div key={"phrase_" + i} className="flex">
                                    {this.insertOvalText({
                                        text: it.customName,
                                        search: currentText,
                                        /*select: currentArea && usePhrases[currentArea].includes(it.id),*/
                                        active: selectPhrase === i,
                                        onClick: this.onClickOvalText.bind(this, it.customName, it.id)
                                    })}
                                </div>))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderContent() {
        const { renderBodyFlag } = this.state;
        return renderBodyFlag ? this.renderBody() : this.renderTeeth();
    }
}
